import React, { useEffect, useState } from "react";
import { CardContainer } from "../../components/Card/CardContainer";
import PageTitleNested from "../../components/PageTitle/PageTitleNested";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import { Col, Divider, Form, Modal, Row, Table } from "antd";
import Button from "../../components/Button/Button";
import { DeleteOutlined, FormOutlined, PlusOutlined } from "@ant-design/icons";
import Text from "../../components/Text/Text";
import { FlexCol } from "../../components/Container/Container";
import { ActionBtn } from "../../components/Button/TableActionButton";
import Input from "../../components/Input/Input";
import Select from "../../components/Select/Select";
import color from "../../resource/color";
import {
  createPayment,
  deletePayment,
  getInvoiceByInvId,
  updatePayment,
} from "../../datasource/InvoiceDatasource";
import { dateFormatter, numberFormatter } from "../../utility/Formatter";
import { useWatch } from "antd/es/form/Form";
import Permission from "../../components/Permission/Permission";
import icon from "../../resource/icon";

function DetailInvoice() {
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const invId = pathSplit[3];
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const [form] = Form.useForm();
  const type = useWatch("paymentChannel", form);

  const navigate = useNavigate();
  const [modal, setModal] = useState<boolean>(false);
  const [data, setData] = useState<any>([]);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [action, setAction] = useState<string>();

  const paymentType = [
    { key: "เช็ค", label: "เช็ค", value: "เช็ค" },
    { key: "เงินโอน", label: "เงินโอน", value: "เงินโอน" },
    { key: "ชำระอื่นๆ", label: "ชำระอื่นๆ", value: "ชำระอื่นๆ" },
  ];

  const getDataById = async () => {
    await getInvoiceByInvId(invId).then((res) => {
      setData(res.data);
    });
  };

  useEffect(() => {
    getDataById();
  }, []);

  const PageNavigate = () => (
    <PageTitleNested
      title={"รายละเอียดเอกสาร"}
      showBack
      onBack={() => navigate(-1)}
      customBreadCrumb={
        <BreadCrumb
          data={[
            { text: "ใบแจ้งหนี้และเอกสาร", path: -1 },
            { text: "รายละเอียดเอกสาร", path: window.location.pathname },
          ]}
        />
      }
    />
  );

  const PageTitle = () => (
    <>
      <Row justify={"space-between"}>
        <Col>
          <Text>รหัสเอกสาร :</Text> <Text fontWeight={700}> {data?.invoiceNo}</Text>
        </Col>
        <Col>
          <Text fontWeight={700}> ยอดรวม {numberFormatter(data?.amt, 2)} บาท</Text>
        </Col>
      </Row>
      <Row justify={"space-between"}>
        <Col>
          <Text>ชื่อร้านค้า :</Text> <Text fontWeight={700}>{data?.billCusName}</Text>
        </Col>
        <Col>
          <Text fontWeight={700}>
            ใช้แล้ว{" "}
            <span style={{ color: color.success }}>
              {numberFormatter(
                data?.invoicePayments?.reduce((acc, inv) => acc + inv?.rvAmt, 0),
                2,
              )}{" "}
              บาท{" "}
            </span>{" "}
            | คงเหลือ{" "}
            {numberFormatter(
              data?.amt - data?.invoicePayments?.reduce((acc, inv) => acc + inv?.rvAmt, 0),
              2,
            )}{" "}
            บาท
          </Text>
        </Col>
      </Row>
      <br />
      <Row justify={"space-between"}>
        <Col>
          <Text>รายการที่ชำระเงิน</Text>
          <br />
          <Text>อัปเดตล่าสุดเมื่อ {dateFormatter(data?.updateDate, true)}</Text>
        </Col>
        <Permission permission={["invoiceList", "create"]}>
          <Col>
            <Button
              disabled={data?.paymentStatus?.includes("ALREADY_PAID")}
              icon={<PlusOutlined />}
              typeButton={
                data?.paymentStatus?.includes("ALREADY_PAID") ? "light-disabled" : "primary"
              }
              title='เพิ่มการชำระเงิน'
              onClick={() => {
                setAction("create");
                setModal(true);
              }}
            />
          </Col>
        </Permission>
      </Row>
    </>
  );

  const columns = [
    {
      title: (
        <Text level={6} fontWeight={600}>
          วันที่อัปเดต
        </Text>
      ),
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (value: any, row: any, index: number) => {
        return (
          <FlexCol>
            <Text level={5}>{dateFormatter(value, true)}</Text>
            <Text level={6} color='Text3'>
              {row.updatedBy}
            </Text>
          </FlexCol>
        );
      },
    },
    {
      title: (
        <Text level={6} fontWeight={600}>
          ประเภท
        </Text>
      ),
      dataIndex: "paymentChannel",
      key: "paymentChannel",
      render: (value: any, row: any, index: number) => {
        return (
          <FlexCol>
            <Text level={5}>{value}</Text>
          </FlexCol>
        );
      },
    },
    {
      title: (
        <Text level={6} fontWeight={600}>
          จำนวนเงิน
        </Text>
      ),
      dataIndex: "rvAmt",
      key: "rvAmt",
      render: (value: any, row: any, index: number) => {
        return (
          <FlexCol>
            <Text level={5}>{numberFormatter(value, 2)}</Text>
            <Text level={6} color='Text3'>
              บาท
            </Text>
          </FlexCol>
        );
      },
    },
    {
      title: "",
      dataIndex: "invoicePaymentId",
      key: "invoicePaymentId",
      render: (value: any, row: any, index: number) => {
        return (
          <Row gutter={16}>
            <Permission permission={["invoiceList", "edit"]}>
              <Col>
                <ActionBtn
                  disabled={data?.paymentStatus?.includes("ALREADY_PAID")}
                  icon={<FormOutlined />}
                  onClick={() => {
                    !data?.paymentStatus?.includes("ALREADY_PAID") &&
                      (setAction("edit"),
                      setModal(true),
                      row.invoicePaymentId &&
                        form.setFieldsValue({
                          invoicePaymentId: row.invoicePaymentId,
                          paymentChannel: row?.paymentChannel?.includes("เช็ค")
                            ? "เช็ค"
                            : row.paymentChannel,
                          receiptNo: row.receiptNo,
                          remark: row.remark,
                          rvAmt: row.rvAmt,
                          chequeNo: row?.paymentChannel?.includes("เช็ค")
                            ? row.paymentChannel.split(" ")[1]
                            : undefined,
                        }));
                  }}
                />
              </Col>
            </Permission>
            <Permission permission={["invoiceList", "delete"]}>
              <Col>
                <ActionBtn
                  disabled={data?.paymentStatus?.includes("ALREADY_PAID")}
                  icon={
                    <DeleteOutlined
                      style={{
                        color: data?.paymentStatus?.includes("ALREADY_PAID")
                          ? color.Disable
                          : color.error,
                      }}
                    />
                  }
                  onClick={() => {
                    !data?.paymentStatus?.includes("ALREADY_PAID") &&
                      (setAction("delete"),
                      Modal.confirm({
                        width: 480,
                        centered: true,
                        icon: null,
                        okText: "ยืนยันการลบ",
                        okButtonProps: { style: { backgroundColor: color.error } },
                        title: (
                          <Text fontWeight={700} level={4}>
                            ต้องการลบการชำระเงินนี้ใช่ไหม?
                          </Text>
                        ),
                        content: (
                          <>
                            <Text color='Text3'>
                              หากลบข้อมูลนี้ ระบบจะไม่สามารถกู้คืนได้ และอาจมีผลต่อยอดชำระรวม
                              โปรดตรวจสอบให้แน่ใจก่อนยืนยัน
                            </Text>
                            <br />
                            <br />
                            <Row gutter={8} justify={"start"}>
                              <Col>
                                <Text color='Text3'>การชำระเงิน : </Text>
                              </Col>
                              <Col>
                                <Text> {row.paymentChannel}</Text>
                              </Col>
                            </Row>
                            <Row gutter={8} justify={"start"}>
                              <Col>
                                <Text color='Text3'>จำนวนเงิน : </Text>
                              </Col>
                              <Col>
                                <Text> {numberFormatter(row.rvAmt, 2)} บาท</Text>
                              </Col>
                            </Row>
                          </>
                        ),
                        cancelText: "ยกเลิก",
                        onOk: async (e) => {
                          if (e) {
                            setIsSuccess(true);
                            await deletePayment({
                              invoicePaymentId: row.invoicePaymentId,
                              updatedBy: `${userProfile.firstname} ${userProfile.lastname}`,
                            }).then((res) => {
                              if (res.success) {
                                getDataById();
                                setTimeout(() => {
                                  setIsSuccess(false);
                                }, 1500);
                              }
                            });
                          }
                        },
                      }));
                  }}
                />
              </Col>
            </Permission>
          </Row>
        );
      },
    },
  ];

  const createData = async (paymentId?: string) => {
    try {
      await form.validateFields().then(async (value) => {
        setIsSuccess(true);
        const payload = { ...value };
        payload.company = userProfile.company;
        payload.invoiceId = data.invoiceId;
        payload.invoiceNo = data.invoiceNo;
        payload.ivAmt = data.amt;
        payload.updatedBy = `${userProfile.firstname} ${userProfile.lastname}`;
        if (value?.paymentChannel?.includes("เช็ค")) {
          payload.paymentChannel = `เช็ค ${value.chequeNo}`;
        }
        if (paymentId) {
          payload.invoicePaymentId = paymentId;
          delete payload.chequeNo;
          await updatePayment(payload).then((res) => {
            if (res.success) {
              setTimeout(() => {
                setIsSuccess(false);
              }, 1500);
            }
          });
        } else {
          await createPayment(payload).then((res) => {
            if (res.success) {
              setTimeout(() => {
                setIsSuccess(false);
              }, 1500);
            }
          });
        }
        form.resetFields();
        setModal(false);
        getDataById();
      });
    } catch (e: any) {
      console.log("e", e);
    }
  };

  return (
    <CardContainer>
      {PageNavigate()}
      <Divider />
      {PageTitle()}
      <br />
      <Table
        dataSource={
          data?.invoicePayments?.sort(
            (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
          ) || []
        }
        columns={columns}
        scroll={{ x: "max-content" }}
        pagination={false}
        size='large'
        tableLayout='fixed'
      />
      {modal && (
        <Modal
          open={modal}
          maskClosable={false}
          centered
          closable={false}
          onCancel={() => {
            setModal(!modal);
            form.resetFields();
          }}
          okText='ยืนยัน'
          onOk={() => {
            createData(form.getFieldValue("invoicePaymentId"));
          }}
        >
          <Row>
            <Text fontWeight={700} level={4}>
              {form.getFieldValue("invoicePaymentId") ? "แก้ไข" : "เพิ่ม"}การชำระเงิน
            </Text>
          </Row>
          <br />
          <Form form={form} layout='vertical'>
            <Form.Item
              name='paymentChannel'
              label='ประเภทการชำระเงิน'
              rules={[
                {
                  required: true,
                  message: "*โปรดเลือกประเภทการชำระเงิน",
                },
              ]}
            >
              <Select
                placeholder='เลือกประเภท'
                data={paymentType}
                disabled={form.getFieldValue("invoicePaymentId")}
              />
            </Form.Item>
            {type == "เช็ค" && (
              <Form.Item
                name='chequeNo'
                label='เลขที่เช็ค'
                rules={[
                  {
                    required: true,
                    message: "*โปรดระบุเลขที่เช็ค",
                  },
                ]}
              >
                <Input placeholder='ระบุรหัสเลขที่รหัส' autoComplete='off' />
              </Form.Item>
            )}
            <Form.Item
              name='receiptNo'
              label='รหัส / เลขที่เอกสาร'
              rules={[
                {
                  required: true,
                  message: "*โปรดระบุรหัส/เลขที่เอกสาร",
                },
              ]}
            >
              <Input placeholder='ระบุรหัส/เลขที่เอกสาร' autoComplete='off' />
            </Form.Item>
            <Form.Item
              name='rvAmt'
              label='จำนวนเงิน'
              rules={[
                {
                  required: true,
                  message: "*โปรดระบุจำนวนเงิน",
                },
                {
                  pattern: /^-?\d+(\.\d+)?$/,
                  message: "*ข้อความเป็นตัวเลขเท่านั้น",
                },
                {
                  validator: async (_, value) => {
                    if (!value) return Promise.resolve();
                    const remain =
                      data.amt - data?.invoicePayments?.reduce((acc, inv) => acc + inv?.rvAmt, 0);
                    if (value == 0) {
                      return Promise.reject(new Error(`จำนวนเงินต้องไม่เท่าเป็น 0 บาท`));
                    }
                    if (value > remain) {
                      return Promise.reject(
                        new Error(
                          `กรุณาระบุจำนวนเงินไม่เกินยอดคงเหลือค้างชำระ ${numberFormatter(remain, 2)} บาท`,
                        ),
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input placeholder='0.00' autoComplete='off' />
            </Form.Item>
            <Form.Item name='remark' label='หมายเหตุเพิ่มเติม'>
              <Input placeholder='ระบุรายละเอียดเพิ่มเติม' autoComplete='off' />
            </Form.Item>
          </Form>
        </Modal>
      )}
      {isSuccess && (
        <Modal open={isSuccess} footer={null} width={220} closable={false} centered>
          <FlexCol align='center' justify='center' style={{ width: 172, height: 172 }}>
            <img src={icon.check_success} />
            <br />
            <Text level={3} fontWeight={700} align='center'>
              {action == "create" ? "เพิ่ม" : action == "edit" ? "แก้ไข" : "ลบ"}ข้อมูลชำระเงิน
              สำเร็จ
            </Text>
          </FlexCol>
        </Modal>
      )}
    </CardContainer>
  );
}

export default DetailInvoice;
